import { render, staticRenderFns } from "./MatterContributionForm.vue?vue&type=template&id=78a7a301&scoped=true"
import script from "./MatterContributionForm.vue?vue&type=script&lang=js"
export * from "./MatterContributionForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=78a7a301&prod&scoped=true&lang=css&external"
import style1 from "./MatterContributionForm.vue?vue&type=style&index=1&id=78a7a301&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a7a301",
  null
  
)

export default component.exports